import React, {useState} from 'react';

import useSearchStore from '../../_Global/SearchStore';
import {toKebabCase} from '../../_Global/searchHelpers';

interface AppliedFacetTagArguments {
    tagLabel: string;
    facetParamName: string;
    facetValue: string;
}

function AppliedFacetTag({tagLabel, facetParamName, facetValue}: AppliedFacetTagArguments) {
    const [inputIsDisabled, setInputIsDisabled] = useState(false);

    const selectedFacetOptions: string[] = useSearchStore((state) => state.getSearchFacetSelectionsByKey(facetParamName));
    const setSearchFacetSelectionsByKey = useSearchStore((state) => state.setSearchFacetSelectionsByKey);

    /**
     * Respond to changes to the "applied filter" inputs
     *
     * @param evt Event that triggered the change
     */
    const onTagChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
        const checkboxValue = evt.target.getAttribute('name') || '';
        const currentSelectedOptions = [...selectedFacetOptions];

        // Disable the button to prevent multiple clicks
        setInputIsDisabled(true);

        // Remove this from the list of selected facets
        const valueIndex = currentSelectedOptions.indexOf(checkboxValue);

        if (valueIndex !== -1) {
            currentSelectedOptions.splice(valueIndex, 1);
            setSearchFacetSelectionsByKey(facetParamName, currentSelectedOptions);
        }
    };

    return (
        <>
            <input className="" disabled={inputIsDisabled} id={`applied-${toKebabCase(facetValue)}`} name={facetValue} onChange={onTagChange} type="checkbox" />
            <label className="" htmlFor={`applied-${toKebabCase(facetValue)}`}>
                <span className="">{tagLabel}</span>
            </label>
        </>
    );
}

export default React.memo(AppliedFacetTag);
